import React from 'react';
import {auth} from "../firebase";
import {ACTION_SET_AUTH_USER} from "../reducers/constants";
import {connect} from "react-redux";
import {showEmailNotVerifiedNotification} from "./notifications/live";
import {isAuthUserEmailVerified} from "../firebase/auth";

/**
 * HOC component to manage authentication states throughout the application as and when needed.
 * @param Component to be rendered
 */
const withAuthentication = (Component) => {
    class WithAuthentication extends React.Component {
        componentDidMount() {
            // When signed out, the parameter authUser is null and we
            // can pass the same null down to the application state.
            auth.doOnAuthStateChanged(authUser => {
                if (authUser) {
                    this.props.onSetAuthUser(authUser);
                    if (!isAuthUserEmailVerified(authUser)) {
                        showEmailNotVerifiedNotification(authUser);
                    }
                } else {
                    this.props.onSetAuthUser(null);
                }
            });
        }

        render() {
            return <Component/>;
        }
    }

    /**
     * Map Redux {@param dispatch} a.k.a. actions to component props
     */
    const mapDispatchToProps = (dispatch) => ({
        onSetAuthUser: (authUser) => dispatch({type: ACTION_SET_AUTH_USER, authUser}),
    });

    return connect(null, mapDispatchToProps)(WithAuthentication);
};

export default withAuthentication;



// WEBPACK FOOTER //
// ./src/components/WithAuthentication.jsx